var map = {
	"./cargo-page.webp": 9349,
	"./dest-abuja.webp": 4956,
	"./dest-benin.webp": 4539,
	"./dest-calabar.webp": 7006,
	"./dest-enugu.webp": 1319,
	"./dest-gombe.webp": 9650,
	"./dest-ibadan.webp": 1425,
	"./dest-jos.webp": 5384,
	"./dest-kaduna.webp": 643,
	"./dest-kano.webp": 7759,
	"./dest-lagos.webp": 8476,
	"./dest-makurdi.webp": 6087,
	"./dest-owerri.webp": 8938,
	"./dest-p-abuja-1.webp": 5476,
	"./dest-p-abuja-2.webp": 3234,
	"./dest-p-abuja.webp": 7085,
	"./dest-p-benin-1.webp": 8660,
	"./dest-p-benin-2.webp": 840,
	"./dest-p-benini.webp": 3378,
	"./dest-p-calabar-1.webp": 6532,
	"./dest-p-calabar-2.webp": 6794,
	"./dest-p-calabar.webp": 7045,
	"./dest-p-enugu-1.webp": 1344,
	"./dest-p-enugu-2.webp": 6405,
	"./dest-p-enugu.webp": 5544,
	"./dest-p-gombe-1.webp": 3773,
	"./dest-p-gombe-2.webp": 7119,
	"./dest-p-gombe.webp": 7189,
	"./dest-p-jos-1.webp": 5958,
	"./dest-p-jos-2.webp": 7076,
	"./dest-p-jos.webp": 9581,
	"./dest-p-kaduna-1.webp": 1922,
	"./dest-p-kaduna-2.webp": 5050,
	"./dest-p-kaduna.webp": 2883,
	"./dest-p-kano-1.webp": 5039,
	"./dest-p-kano-2.webp": 1593,
	"./dest-p-kano.webp": 7068,
	"./dest-p-lagos-1.webp": 6089,
	"./dest-p-lagos-2.webp": 8088,
	"./dest-p-lagos.webp": 9787,
	"./dest-p-makurdi-1.webp": 6479,
	"./dest-p-makurdi-2.webp": 8213,
	"./dest-p-makurdi.webp": 4389,
	"./dest-p-owerri-1.webp": 8792,
	"./dest-p-owerri-2.webp": 1719,
	"./dest-p-owerri.webp": 6144,
	"./dest-p-ph-1.webp": 5549,
	"./dest-p-ph-2.webp": 7106,
	"./dest-p-ph.webp": 7679,
	"./dest-p-yola-1.webp": 742,
	"./dest-p-yola-2.webp": 6892,
	"./dest-p-yola.webp": 9582,
	"./dest-portharcourt.webp": 8743,
	"./dest-yola.webp": 556,
	"./exclusive-bg.webp": 4821,
	"./logo.webp": 4886,
	"./map1.webp": 8413,
	"./service-private-hire.webp": 8542,
	"./service-purchase-part.webp": 7697,
	"./service-repairs.webp": 3898,
	"./service-training.webp": 7540,
	"./slider1.webp": 9673,
	"./slider2.webp": 3176,
	"./slider3.webp": 9588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;